module.exports = __webpack_public_path__ + "img/delete.13ffd4e3.svg";